import { Component, ErrorInfo, ReactNode } from 'react';

import lang from '../../lib/language';
import { LoggerService } from '../../lib/services/logger/Logger.service';

import CrashImg from '../../assets/img/CrashImg.png';
import Button from '../../shared_components/Button/Button';

// import { ErrorType, logErrorToFirestore } from '../../util/firebase/firebase';
import styles from './ErrorBoundary.module.scss';

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
  error: Error | null;
};

const logger = LoggerService.getLogger();

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(): Partial<State> {
    return { hasError: true };
  }

  async componentDidCatch(error: Error, errorInfo: ErrorInfo): Promise<void> {
    logger.errorBoundary(error);
    this.setState({ error });

    // await logErrorToFirestore({
    //   error: error.message,
    //   errorStack: (error.stack || '') + (errorInfo.componentStack ? `\nComponent stack:\n${errorInfo.componentStack}` : ''),
    //   errorType: ErrorType.CrashError,
    // });
  }

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div className={styles.errorContainer}>
          <div className={styles.errorContentWrapper}>
            <div className={styles.errorContent}>
              <img src={CrashImg} alt="crash-img" className={styles.image} />
              <div>{lang.commonSomethingWentWrongText()}</div>
            </div>
            <Button
              className={styles.button}
              onClick={this.handleRefresh}
              biggerFontSize
            >
              {lang.commonSomethingWentWrongButtonText()}
            </Button>
          </div>
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
